import type { DashboardCampaign } from "@adpilot/shared";

export type CampaignTableSortKey = "impressions";
export type CampaignTableSortDirection = "asc" | "desc";

function campaignSortValue(campaign: DashboardCampaign, key: CampaignTableSortKey): number {
  return campaign.metrics[key];
}

export function sortCampaignTableCampaigns(
  campaigns: readonly DashboardCampaign[],
  key: CampaignTableSortKey | null,
  direction: CampaignTableSortDirection,
): DashboardCampaign[] {
  if (key == null) return [...campaigns];

  return [...campaigns].sort((left, right) => {
    const comparison = campaignSortValue(left, key) - campaignSortValue(right, key);
    return direction === "asc" ? comparison : -comparison;
  });
}
